import { render, staticRenderFns } from "./BaseMapPolygons.vue?vue&type=template&id=36a48a52"
import script from "./BaseMapPolygons.vue?vue&type=script&lang=js"
export * from "./BaseMapPolygons.vue?vue&type=script&lang=js"
import style0 from "./BaseMapPolygons.vue?vue&type=style&index=0&id=36a48a52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports